/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable no-param-reassign */

import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { object } from 'prop-types';
import mbpLogger from '@module-logger/mbp';

import { GRAPHQL_ENV } from '../../../gql';
import CardIsleTemplate from './CardIsleTemplate';
import Reference from '../UniversalTemplate/Templates/Lander/includeRefs';
import isSingleSource from '../../../helpers/isSingleSource';

const CardIsleTemplateQuery = ({
    page, brand,
}) => {
    const useSingleSource = isSingleSource(page?.type, page?.path);
    let altPath = '';
    if (useSingleSource.brand) {
        brand = useSingleSource.brand;
        altPath = useSingleSource.path;
        page.content_type = useSingleSource.content_type;
    }

    const CARDISLE_QUERY = gql`
            query CardIsleTemplateQuery {
                findContent(brand: "${brand['domain']}", environment: "${GRAPHQL_ENV}", locale: "en-us", contentType: "universal_lander", includeRefs: ${Reference}, query:"{\\"url\\": {\\"$in\\": [\\"${altPath || page.path}\\"]}}",) {
                       content
                   }
                }
        `;

    const { loading, error, data } = useQuery(CARDISLE_QUERY);
    if (loading) return <></>;
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: `Failed to fetch content data for: content type CardIsleTemplateQuery query ${CARDISLE_QUERY} on brand ${brand.domain}`,
        });
    }
    let rows = [];
    if (data.findContent.content.entries[0].rows.length) {
        rows = data.findContent.content.entries[0].rows;
        return <CardIsleTemplate rows={rows} page={{ ...page, page_settings: data?.findContent?.content?.entries[0].page_settings }} data={data?.findContent?.content?.entries?.[0]} />;
    }
    return <></>;
};

CardIsleTemplateQuery.propTypes = {
    page: object.isRequired,
    brand: object.isRequired,
};

export default CardIsleTemplateQuery;
